import { useEffect, useState } from 'react';
import LibModal from '../../../features/LibModal/LibModal';
import { useTemplate } from '../../../features/template/TemplateProvider';
import PageTitle from '../../../utils/PageTitle';
import BasicInformation from './Components/BasicInformation';
import InvoiceNote from './Components/InvoiceNote';
import { ApiLoadInvoiceInfo } from './InvoiceConfigOperation';
import UpdateInformationModal from './Modals/UpdateInformationModal';
import UpdateInvoiceNoteModal from './Modals/UpdateInvoiceNoteModal';

const initialState = {
    invConfig: {
        organization: '',
        phoneNumber: '',
        email: '',
        address: '',
        signatory1: '',
        signatory2: '',
        validity: 0
    },
    invNote: {
        noteTitle: '',
        noteDescription: ''
    }
};

function InvoiceConfigPage() {
    const [invConfigInfo, setInvConfigInfo] = useState(initialState);
    const [reloadKey, setReloadKey] = useState(0);
    const [openModal, setOpenModal] = useState('');

    const { setMessage } = useTemplate();

    // -- Load invoice list data
    useEffect(() => {
        setInvConfigInfo(initialState);
        ApiLoadInvoiceInfo()
            .then(({ data }) => {
                setInvConfigInfo(data);
            })
            .catch((err) => {
                setInvConfigInfo(initialState);
                setMessage({ type: 'error', text: err.toString(0) });
            });
    }, [setMessage, reloadKey]);

    const handleReload = () => {
        setReloadKey((d) => d + 1);
    };

    // set page title
    PageTitle(`Invoice Setting`);

    return (
        <div className="flex justify-center">
            <div className=" inner_page_cont w-full max-w-[900px] p-4 md:p-[50px]">
                <div className="w-full flex items-center justify-between  border-b border-primary-100 pb-4 mb-5">
                    <h1 className="text-3xl font-medium text-primary">Invoice Config</h1>
                    {/* <ButtonPrimary
                        title="Edit Information"
                        onClick={() => setOpenModal('edit_info')}
                    /> */}
                </div>

                <BasicInformation data={invConfigInfo?.invConfig} setOpenModal={setOpenModal} />

                <hr className="my-3" />

                <InvoiceNote data={invConfigInfo?.invNote} setOpenModal={setOpenModal} />

                {openModal === 'update_info' && (
                    <LibModal title="Update Information" setOpen={setOpenModal}>
                        <UpdateInformationModal
                            data={invConfigInfo?.invConfig}
                            closeModal={() => setOpenModal('')}
                            handleReload={handleReload}
                        />
                    </LibModal>
                )}

                {openModal === 'update_note' && (
                    <LibModal title="Update Note" setOpen={setOpenModal}>
                        <UpdateInvoiceNoteModal
                            data={invConfigInfo?.invNote}
                            closeModal={() => setOpenModal('')}
                            handleReload={handleReload}
                        />
                    </LibModal>
                )}
            </div>
        </div>
    );
}

export default InvoiceConfigPage;
